import { PublicLayout } from "@/components/layout/PublicLayout";
import { LEGAL_UPDATED } from "@/data/legal";

export const LegalPage = ({ title, intro, sections, testid }) => {
  return (
    <PublicLayout>
      <div className="mx-auto max-w-3xl px-6 py-16 md:py-24 lg:px-8" data-testid={testid}>
        <p className="font-body text-xs font-semibold uppercase tracking-[0.2em] text-primary">Legal</p>
        <h1 className="mt-3 font-heading text-4xl font-bold tracking-tighter text-foreground sm:text-5xl">
          {title}
        </h1>
        <p className="mt-3 font-body text-sm font-medium text-muted-foreground">Last updated: {LEGAL_UPDATED}</p>
        {intro && <p className="mt-6 font-body leading-relaxed text-muted-foreground">{intro}</p>}

        <div className="mt-10 space-y-8">
          {sections.map((s) => (
            <section key={s.heading}>
              <h2 className="font-heading text-lg font-semibold tracking-tight text-foreground">{s.heading}</h2>
              <p className="mt-2 font-body leading-relaxed text-muted-foreground">{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </PublicLayout>
  );
};
